import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Define a type for the slice state
interface stateType {
  restaurant?: any,
  phone?: any,
  closing_time?: any,
  opening_time?: any,
  restaurantLoading?: boolean
}
const initialState: stateType = {
  restaurant: {},
  restaurantLoading: false,
}

export const SelectedRestaurant = createSlice({
  name: 'SelectedRestaurant',
  initialState,
  reducers: {
    setSelectedRestaurant: (state, val: PayloadAction<stateType>) => {
      state.restaurant = val.payload.restaurant;
      if (val.payload.closing_time) state.closing_time = val.payload.closing_time;
      if (val.payload.opening_time) state.opening_time = val.payload.opening_time;
      state.restaurantLoading = false;
    },
    setRestaurantLoading: (state, action: PayloadAction<boolean>) => {
      state.restaurantLoading = action.payload;
    }
  },
})

// Action creators are generated for each case reducer function
export const { setSelectedRestaurant, setRestaurantLoading } = SelectedRestaurant.actions;
export default SelectedRestaurant.reducer;
